import script from "./CollapsibleMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsibleMenu.vue?vue&type=script&setup=true&lang=js"

import "./CollapsibleMenu.vue?vue&type=style&index=0&id=8d62108a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d62108a"]])

export default __exports__